import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './container/App';
import reportWebVitals from './reportWebVitals';

// azure imports
import { MsalProvider } from '@azure/msal-react';
import {  pca } from './components/Authentication/authConfig';

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
     <MsalProvider instance={pca}>
          <App />
      </MsalProvider>
 );

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
